import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import { clone } from '../../../core/utils';
import { formatDate } from '../../../components/renderers';
import { create, isValid } from '../../../components/form';
import { extendedstyles } from '../../appstyles';

const s:any ={
  reqform: {
    //
  },
};

class TeamPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    this.state = {
      source: {},
      preview: false,
      valid: false,
      count: 0,
    };
  }

  componentDidMount() {
    console.log(this.props?.data);
    this.props.setValid(this.state.valid);
  }

  formconfig = () => {
    //combo.inputLabelProps => cilp
    //const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service:{
            name:'team',
            title:'Team',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Name',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['dcd','Date Created'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[
                {id:'tmi',label:'Team',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'team'}},
                // {id:'tmd',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'tcd',label:'Date Created',type:'df',req:0,ops:{}},
                // {id:'tst',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add'},
        panels: {add:'simple'}
    };
    return config;
  };

  setValid = (data: any) => {
    const sconfig = this.formconfig();
    const { mode } = this.props;
    const valid = ['del', 'delete'].includes(mode)
      ? true
      : isValid(sconfig, data, mode);
    //console.log('valid:',valid);

    //const valid = (!!newdata.nam && !!newdata.agc && !!newdata.mbn && !!newdata.lci);
    //const valid = (!!data.wsu && !!data.cbu && !!data.cbc && !!data.cba);
    //console.log('valid:',valid);
    this.props.setValid(valid);
  };

  onChange = (name: any) => (value: any, selected: any) => {
    const { data } = this.props;
    const newdata = { ...data.data, [name]: value };
    const displayValues = { ...(data.displayValues || {}) };
    if (selected && typeof selected === 'object' && selected.nam) {
      displayValues[name] = selected.nam;
    } else {
      delete displayValues[name];
    }
    this.setValid(newdata);
    this.props.setItem('data', 'data', newdata);
    this.props.setItem('data', 'displayValues', displayValues);
  };

  makeform = () => {
    const config = this.formconfig();

    const { record, extras, classes } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    const form = create(
      mode,
      sdata,
      record,
      formatters,
      onChange,
      classes,
      extras
    );
    return form;
  };

  render() {
    //const {data,classes} = this.props;
    const form = this.makeform();
    return form;
  }
}

TeamPanel.propTypes = {
  classes: PropTypes.object ,
};

export default TeamPanel;
